/**
 * @packageDocumentation
 * @module HackerAPI.Pipeline.Stage
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
import Base from "../../base/base";
/**
 * A data container for pipeline stage related data. It also has static methods for interfacing with
 * hackerapi.com.
 * @class Stage
 * @extends { HackerAPI.Base }
 */
var Stage = /** @class */ (function (_super) {
    __extends(Stage, _super);
    /**
     * Creates a stage instance
     * @constructor
     * @param stage
     */
    function Stage(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, permissions = _b.permissions, count = _b.count, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * The ID of this stage in the pipeline
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of this stage in the pipeline
         * @type { string }
         */
        _this.name = name;
        /**
         * The list of access types and who has permissions for the various types
         * @todo Create Permissions class
         * @type { Object }
         */
        _this.permissions = permissions;
        /**
         * The number of claims at this stage in the pipeline
         * @type { number }
         */
        _this.count = count;
        _this.createdAt = parseDate(created_at || createdAt);
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Fetches all the stages for a pipeline from hackerapi
     * @param pipeline
     * @param pipeline.id
     * @param token
     * @returns
     */
    Stage.fetchAll = function (_a, token) {
        var pipelineId = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/stages",
            method: "GET",
            token: token
        }).then(function (data) { return data.map(function (datum) { return new Stage(datum); }); });
    };
    /**
     * Fetches a the stage for a pipeline from hackerapi
     * @param pipeline
     * @param pipeline.id
     * @param stage
     * @param stage.id
     * @param token
     * @returns
     */
    Stage.fetch = function (_a, _b, token) {
        var pipelineId = _a.id;
        var stageId = _b.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/stages/" + stageId,
            method: "GET",
            token: token
        }).then(function (data) { return new Stage(data); });
    };
    /**
     * Creates a pipeline stage on hackerapi
     * @param pipeline
     * @param pipeline.id
     * @param stage
     * @param user
     * @param user.token
     * @returns
     */
    Stage.create = function (_a, stage, token) {
        var pipelineId = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/stages",
            method: "POST",
            token: token,
            body: stage.toHackerAPIFormat()
        }).then(function (data) { return new Stage(data); });
    };
    /**
     * Updates a pipeline stage on hackerapi
     * @param pipeline
     * @param pipeline.id
     * @param stage
     * @param token
     * @returns
     */
    Stage.update = function (_a, stage, token) {
        var pipelineId = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/stages/" + stage.id,
            method: "PUT",
            token: token,
            body: stage.toHackerAPIFormat()
        }).then(function (data) { return new Stage(data); });
    };
    /**
     * Deletes a pipeline stage on hackerapi
     * @param pipeline
     * @param pipeline.id
     * @param stage
     * @param stage.id
     * @param token
     * @returns
     */
    Stage.delete = function (_a, _b, token) {
        var pipelineId = _a.id;
        var stageId = _b.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/stages/" + stageId,
            method: "DELETE",
            token: token
        });
    };
    return Stage;
}(Base));
export default Stage;
//# sourceMappingURL=stage.js.map